import { MOKA_SERVICE_HOST } from '../constants';

export const BUSINESS_DATA_URL = `${MOKA_SERVICE_HOST}/business-service/v1/business/`;
export const BUSINESS_DATA_URL_V3 = `${MOKA_SERVICE_HOST}/business-service/v3/businesses/`;
export const UPLOAD_KTP_IMAGE_URL_UPLOAD_SERVICE = `${MOKA_SERVICE_HOST}/upload/image?crop=false`;
